if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // Listen for the Add to Cart button click
  document.getElementById("ProductSubmitButton-template--24028205908339__main").addEventListener("click", function (e) {
  // e.preventDefault();
  // Add upsell products if any are checked
  const checkedProducts = document.querySelectorAll(".upsell-product:checked");
    console.log("checked",checkedProducts);
    if (checkedProducts.length > 0) {
      console.log("if is working");
      // const mainProductId = document.querySelector(".product-form input[name='id']").value;
      const variantElement = document.querySelector(".product-form select[name='id']") || document.querySelector(".product-form input[name='id']");
      const mainProductId = variantElement ? variantElement.value : null;
    
      console.log("Main Product Variant ID:", mainProductId);
      
      // const mainProductQuantity = document.querySelector(".product-form input[name='quantity']").value;
      
      // console.log("Main Product Quantity:", mainProductQuantity);
      
      // const mainProductQuantity = document.querySelector(".product-form input[name='quantity']").value;
      
      // Prepare an array to hold all cart items
      let cartItems = [
        {
            id: mainProductId,
        },
      ];
      checkedProducts.forEach((checkbox) => {
        const productId = checkbox.getAttribute("data-pdid");
        cartItems.push({
          id: productId,
          quantity: 1, // Default quantity for upsell products
        });
      });
        console.log('cart items ==>',cartItems)
        addProductsToCart(cartItems);
    }
  });
});

async function addProductsToCart(cartItems) {
  console.log('cart items in add to cart function ==>',cartItems)
  try {
    const formData = {
      items: cartItems.map(item => ({
        id: Number(item.id),
        quantity: Number(item.quantity),
      })),
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      const errorDetails = await response.json();
      console.error("Error adding to cart:", errorDetails);
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    console.log("Cart updated successfully:", data);
  } catch (error) {
    console.error("Failed to add to cart:", error);
  }
}
